module.exports = __webpack_public_path__ + "img/iconfinder_triangle.bc7a70d3.svg";